export default __webpack_public_path__ + "static/grid-3a1bb48d4830c7310a0cab04f5951c9c.svg";